const WaitlistModel = {
  created: "date",
}

export default WaitlistModel
